import React from "react";

const SpecialismFilter = ({ specialisms, selected, onChange }) => {
  return (
    <div className="specialism-filter">
      {specialisms.map((spec) => (
        <label key={spec.name} className="specialism-option">
          <input
            type="checkbox"
            checked={selected.includes(spec.name)}
            onChange={() => onChange(spec.name)}
          />
          <span className="checkbox-box" />
          {spec.name}
          <span className="count">{spec.count}</span>
        </label>
      ))}
    </div>
  );
};

export default SpecialismFilter;
